import React, { createContext, ReactNode, useContext, useMemo } from 'react';

import { MeMessagesType } from '../V2/model/interfaces/MeMessagesType';
import { useGetMeMessages } from '../V2/services/notifications/useGetMeMessages';

const MeMessagesContext = createContext<MeMessagesType>({
  unread_visitor_notifications: 0,
  unread_message_notifications: 0
});

export const MeMessagesProvider = ({ children }: { children: ReactNode }) => {
  const { data } = useGetMeMessages();

  const value = useMemo(
    () =>
      data?.data ?? {
        unread_visitor_notifications: 0,
        unread_message_notifications: 0
      },
    [data?.data]
  );

  return <MeMessagesContext.Provider value={value}>{children}</MeMessagesContext.Provider>;
};

export const useMeMessages = () => {
  const context = useContext(MeMessagesContext);
  if (!context) {
    throw new Error('useMeMessages must be used within a MeMessagesProvider');
  }
  return context;
};
